<template>

<svg xmlns="http://www.w3.org/2000/svg"  viewBox="-11.5 780.5 24 24" >
<path d="M8.34,789.62c1.43-2.04,0.94-4.85-1.1-6.28c-1.79-1.25-4.22-1.05-5.77,0.49l-0.94,0.93l-0.93-0.93
	c-1.76-1.76-4.62-1.77-6.38-0.01c-1.54,1.54-1.77,3.96-0.53,5.75c-0.56,0.83-0.86,1.81-0.86,2.81v5.02h4.07
	c0.25,0.58,0.6,1.1,1.04,1.54l3.56,3.56l3.56-3.56c0.44-0.44,0.8-0.97,1.05-1.54h4.07v-5.01C9.18,791.4,8.88,790.44,8.34,789.62z
	 M1.81,784.17c1.57-1.57,4.12-1.57,5.69,0c1.34,1.34,1.56,3.44,0.53,5.03c-0.95-1.17-2.38-1.84-3.88-1.84H4.07l0.5,0.5
	c1.25,0.12,2.4,0.75,3.16,1.74c-0.07,0.09-0.15,0.17-0.23,0.25l-2.75,2.75c0.58-1.64,0.16-3.46-1.07-4.69l-2.82-2.82L1.81,784.17z
	 M3.35,788.26c1.57,1.56,1.59,4.09,0.03,5.66c-1.56,1.57-4.09,1.58-5.66,0.03c-1.57-1.56-1.58-4.09-0.03-5.66
	c0.01-0.01,0.02-0.02,0.03-0.03l2.82-2.82L3.35,788.26z M-6.44,784.17c1.57-1.57,4.12-1.57,5.69,0l0.93,0.93l-2.82,2.82
	c-1.23,1.23-1.64,3.05-1.06,4.69l-2.75-2.75c-0.09-0.09-0.18-0.19-0.27-0.3c0.77-0.97,1.9-1.59,3.14-1.7l0.5-0.5h-0.08
	c-1.48,0-2.89,0.66-3.85,1.8C-8,787.57-7.76,785.5-6.44,784.17z M-3.83,794.03l-0.38-0.39c-0.39,1.05-0.41,2.2-0.08,3.27h-3.41
	v-4.53c0-0.85,0.24-1.69,0.69-2.41c0.07,0.08,0.14,0.16,0.21,0.23l4.09,4.09c0.73,0.73,1.7,1.19,2.73,1.29
	c-0.85,0.85-2,1.32-3.19,1.32h-0.62C-4.1,795.98-4.12,794.97-3.83,794.03L-3.83,794.03z M3.7,798.59l-3.21,3.21l-3.21-3.21
	c-0.35-0.35-0.64-0.75-0.86-1.2h0.41c1.38,0,2.7-0.57,3.65-1.57c0.95,1.01,2.27,1.58,3.65,1.58h0.42
	C4.34,797.84,4.05,798.25,3.7,798.59z M8.68,796.91H5.28c0.34-1.07,0.31-2.22-0.08-3.27l-0.38,0.38c0.29,0.94,0.28,1.96-0.05,2.88
	H4.15c-1.19,0-2.34-0.47-3.19-1.31c1.05-0.09,2.04-0.55,2.79-1.3l4.09-4.09c0.06-0.06,0.12-0.12,0.17-0.19
	c0.44,0.71,0.67,1.53,0.67,2.36V796.91z"/>
<circle cx="0.5" cy="791.31" r="2.34"/>
</svg>

</template>